module.exports = __webpack_public_path__ + "static/media/photo256.67c63197.jpg";